import { Category } from '../../types/Category';
import {
  ALL_CUSTOM_PHOTO_GOODS_URL_PATH,
  BABY_BOOKS_URL_PATH, BEST_SELLERS_URL_PATH, BIRTHDAY_PHOTO_CARDS_URL_PATH,
  FAMILY_BOOKS_URL_PATH,
  FRAMED_PRINTS_URL_PATH, GIFTS_UNDER_50_URL_PATH,
  HARDCOVER_BOOKS_URL_PATH, JUST_BECAUSE_CARDS_URL_PATH,
  LAYFLAT_BOOKS_URL_PATH,
  PAPERBACK_BOOKS_URL_PATH,
  PHOTO_BOOKS_URL_PATH,
  PHOTO_CALENDARS_URL_PATH, PHOTO_CARDS_URL_PATH, PHOTO_GRADUATION_CARDS_URL_PATH,
  PHOTO_HOLDERS_URL_PATH,
  PHOTO_PRINTS_URL_PATH,
  POSTER_PRINTS_URL_PATH, SAVE_THE_DATE_CARDS_URL_PATH,
  THANK_YOU_CARDS_URL_PATH,
  TRAVEL_BOOKS_URL_PATH,
  WALL_FRAMES_URL_PATH,
  WEDDING_BOOKS_URL_PATH, WEDDING_CARDS_URL_PATH, WEDDING_FRAMES_URL_PATH, WEDDING_GIFTS_URL_PATH,
  WEDDING_GUEST_BOOKS_URL_PATH, WEDDING_PRINTS_URL_PATH, WEDDING_THANK_YOU_CARDS_URL_PATH, WEDDING_URL_PATH
} from '../../components/constants/products';

export const isGiftCards = ({ name }: Category): boolean => name === 'Gift Cards';
export const isWeddingCollections = ({ name }: Category): boolean => name === 'Wedding Collections';

export const shouldShowPrices = (category: Category): boolean => category.name !== 'Wedding Suites';
export const shouldHideProducts = (category: Category): boolean => isGiftCards(category) || isWeddingCollections(category);

const URL_PATH_DESCRIPTIONS = {

  [PHOTO_BOOKS_URL_PATH]: 'Make Personalized Photo Books, made to honor your meaningful moments with intention.',
  [WEDDING_BOOKS_URL_PATH]: 'For a wedding that is uniquely yours.',
  [LAYFLAT_BOOKS_URL_PATH]: 'Explore our premium line of Layflat Photo Albums, design forward and built to last.',
  [HARDCOVER_BOOKS_URL_PATH]: 'Mark life’s many milestones with heirloom-quality hardback albums handcrafted from time-tested materials.',
  [PAPERBACK_BOOKS_URL_PATH]: 'High-quality and extra customizable photo books that make good printing habits easy.',
  [TRAVEL_BOOKS_URL_PATH]: 'Our premium photo books feature quality materials and elevated design to make your stories last.',
  [BABY_BOOKS_URL_PATH]: 'Share a love for printed photos from an early age with gifts they’ll enjoy for a lifetime.',
  [FAMILY_BOOKS_URL_PATH]: 'Bring permanence to the memories that make each day the ones you cherish.',
  [WEDDING_GUEST_BOOKS_URL_PATH]: 'Shop our collection of unique Wedding Guest Books, made to match any theme.',
  [PHOTO_PRINTS_URL_PATH]: 'Best-in-class photo prints.',
  [POSTER_PRINTS_URL_PATH]: 'Your stories, on display.',
  [PHOTO_HOLDERS_URL_PATH]: 'Effortless ways to display your everyday.',
  [FRAMED_PRINTS_URL_PATH]: 'Preserve their moments with modern design.',
  [WALL_FRAMES_URL_PATH]: 'Refresh your decor.',
  [PHOTO_CALENDARS_URL_PATH]: 'Made for year-round joy.',
  [THANK_YOU_CARDS_URL_PATH]: 'A little gratitude goes a long way, send a custom greeting to say thanks.',
  [PHOTO_CARDS_URL_PATH]: 'Personalized greetings, made premium.',
  [BIRTHDAY_PHOTO_CARDS_URL_PATH]: 'For their special day.',
  [JUST_BECAUSE_CARDS_URL_PATH]: 'Make their mail day.',
  [PHOTO_GRADUATION_CARDS_URL_PATH]: 'Celebrate your grad with loved ones.',
  [WEDDING_CARDS_URL_PATH]: 'Modern, yet timeless, wedding card collection.',
  [SAVE_THE_DATE_CARDS_URL_PATH]: 'Mark their calendars.',
  [WEDDING_THANK_YOU_CARDS_URL_PATH]: 'Say thank you, in print.',
  [WEDDING_URL_PATH]: 'Custom wedding keepsakes, books, and gifts.',
  [WEDDING_PRINTS_URL_PATH]: 'To have and to hold.',
  [WEDDING_GIFTS_URL_PATH]: 'Make the most of your wedding photos.',
  [WEDDING_FRAMES_URL_PATH]: 'Your wedding highlights, on display.',
  [BEST_SELLERS_URL_PATH]: 'Shop our bestsellers.',
  [ALL_CUSTOM_PHOTO_GOODS_URL_PATH]: 'Shop all custom Photo Goods.',
  [GIFTS_UNDER_50_URL_PATH]: 'Gifts Under $50'
};

export const getH2Text = (urlPath: string): string => {
  return URL_PATH_DESCRIPTIONS[urlPath];
};

